module.exports = __webpack_public_path__ + "img/ring_r_l_null_1.4ff1b11c.png";